
// import { Link } from 'react-router-dom';
// import DisplayPrixForm from '../../components/DisplayPrixForm';
// import axiosInstance from "../../helpers/Axios";

const Prix = () => {

    return (
        <div id="Prix">
            <div id="title">
                <h1>Les prix des cours</h1>
            </div>
            <div id="cell-57acaa5ace2a000000022f95" className="column-content">
                <p><u>Paiement à l'année pour la saison 2026-2027</u></p>
                <p>.</p>
                {/* align="center" border="0" */}
                <table >
                    <tbody>
                        <tr>
                            <td>&nbsp;</td>
                            <td><strong>sept/juin</strong></td>
                        </tr>
                        <tr>
                            <td><strong>1h</strong></td>
                            <td><strong>245€</strong></td>
                        </tr>
                        <tr>
                            <td><strong>1h30</strong></td>
                            <td><strong>310€</strong></td>
                        </tr>
                        <tr>
                            <td><strong>2h</strong></td>
                            <td><strong>360€</strong></td>
                        </tr>
                        <tr>
                            <td><strong>2h30</strong></td>
                            <td><strong>380€</strong></td>
                        </tr>
                        <tr>
                            <td><strong>3h</strong></td>
                            <td><strong>425€</strong></td>
                        </tr>
                        <tr>
                            <td><strong>3h30</strong></td>
                            <td><strong>430€</strong></td>
                        </tr>
                        <tr>
                            <td><strong>le forfait=4h et +</strong></td>
                            <td><strong>450€</strong></td>
                        </tr>
                    </tbody>
                </table>

                <p>Réduction pour cours et stage: -10% si 2 inscrits d'une même famille ou famille nombreuse.</p>

                <p>Si vous rencontrez des difficultés pour le paiement, vous pouvez prendre contact avec nous, nous trouverons un arragement.</p>

                <p>&nbsp;</p>

                <p>Pour le cours de préparation physique du mercredi: Possibilité de carte de 10 séances pour 100€ valable toute l'année. On peut venir quand on veut de manière occasionnelle.</p>
            </div>
        </div>
    )
};

export default Prix;
